import { ShieldCheck } from "lucide-react";
import { Input } from "../ui/input";
import { SchoolInput } from "../SchoolInput";
import { Section, Field } from "./builderUi";

export const PersonalDetailsSection = ({ form, set, email }) => (
  <Section accent="bg-cobalt" title="Personal details" subtitle="Tell us a bit about you and your school." testid="builder-personal">
    <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
      <Field label="Full name">
        <Input data-testid="builder-fullname" value={form.full_name} onChange={set("full_name")} placeholder="Alice Smith" />
      </Field>
      <Field label="Email address" hint="This is the address on your account. A .edu address is a helpful trust signal.">
        <div className="relative">
          <Input data-testid="builder-email" value={email || ""} readOnly className="pr-24 text-olive" />
          {/\.edu$/i.test(email || "") && (
            <span className="absolute inset-y-1 right-1 inline-flex items-center gap-1 rounded-full bg-grass/15 px-2.5 text-[13px] font-semibold uppercase tracking-[0.14em] text-grass ring-1 ring-inset ring-grass/30" data-testid="builder-edu-badge">
              <ShieldCheck className="h-3 w-3" strokeWidth={2} /> .edu
            </span>
          )}
        </div>
      </Field>
      <Field label="School">
        <SchoolInput testid="builder-school" value={form.school} onChange={(v) => set("school")(v)} placeholder="Start typing your school name" />
      </Field>
      <Field label="Program / Major" optional>
        <Input data-testid="builder-program" value={form.program} onChange={set("program")} placeholder="Computer Science" />
      </Field>
      <Field label="Graduation year" optional>
        <Input data-testid="builder-gradyear" value={form.grad_year} onChange={set("grad_year")} placeholder="2027" maxLength={4} inputMode="numeric" />
      </Field>
      <Field label="Phone number" optional hint="Private. Only our review team sees it.">
        <Input data-testid="builder-phone" value={form.phone} onChange={set("phone")} placeholder="+1 (555) 123-4567" />
      </Field>
      <Field label="Location" optional>
        <Input data-testid="builder-location" value={form.location} onChange={set("location")} placeholder="Boston, MA" />
      </Field>
    </div>
  </Section>
);
